import React from 'react';
import { useFieldDependencies } from 'App/helpers/fieldDependencies';

type Options<V> = Parameters<typeof useFieldDependencies<V>>[0];

type Props<V> = Options<V> & {
	children: (fieldDependencies: ReturnType<typeof useFieldDependencies<V>>) => React.ReactNode;
};

/** `useFieldDependencies` for class components. */
const FieldDependencies = <V,>({ children, ...options }: Props<V>) => <>{children(useFieldDependencies(options))}</>;

export default FieldDependencies;
